import classes from "../forms/forms.module.css";

const InputText = ({text,value, placeholder, onChange, required}) => {
    return (
        <di>
            <label className={classes.label}>
                {text} {required && <b className={classes.required}>*</b>}
            </label>
            <input
                placeholder={placeholder}
                type="text"
                className={classes.input}
                value={value}
                onChange={onChange}
                required
            />
        </di>
    )
}

export default InputText;